<template>
  <div
    flex="~ row lg:row"
    px="4"
    py="19px"
    font="500"
    class="text bg-#F7F5F1"
    color="grey-600"
    rounded-lg
  >
    <slot></slot>
  </div>
</template>
